<template>
	<div class="landing-container">
		<a-modal
		      v-model="modal2Visible"
		      title="优普道集团"
			  okText='确定'
			  cancelText="取消"
		      centered
		      @ok="submitInfo"
		>	
			<img src="@/assets/image/landing/title.png" alt=""  width="100%"/>
			<div class="modal-select">
		      <a-select :value="fromData.type" style="width: 100%" @change="typeChange">
		      	<a-select-option :value="item.id" v-for="(item,index) in passagetype" :key='index'>
		      		{{item.name}}
		      	</a-select-option>
		      </a-select>
			</div>
			<div class="modal-select">
			  <a-select :value="fromData.province_name" style="width: 100%" @change="handleChange">
			  	<a-select-option :value="item.name" v-for="(item,index) in address" :key='index'>
			  		{{item.name}}
			  	</a-select-option>
			  </a-select>
			</div>
			<div class="modal-select">
				<a-input v-model="fromData.username" placeholder="请输入您的姓名" >
					<a-icon slot="prefix" type="user" />
				</a-input>
			</div>
			<div class="modal-select">
			  <a-input v-model="fromData.phone" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入您的联系方式" >
				<a-icon slot="prefix" type="phone" />
			  </a-input>
			</div>
			  
		</a-modal>
		
		<landing-header></landing-header>
		<div @click="setModal">
			<Banner :list="banners" :myHeight="180" :hadFrom="false"></Banner>
		</div>
		<!-- <img src="@/assets/image/landing/banner.png" width="100%" /> -->
		<div class="main-container">
			<div class="advisory common-content py-3">
				<div class="advisory-banner">
					<div class="swiper-container banner-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item, index) in swiperImgs" :key="index" @click="setModal">
								<div class="bg-cent banner-img" :style="{backgroundImage: 'url(' + item + ')'  }"></div>
								<!-- <img  src="@/assets/image/086.png" alt="" /> -->
							</div>
						</div>
						<div class="banner-title">成功案例展示</div>
						<div class="swiper-pagination banner-pagination"></div>
					</div>
				</div>
				<div class="advisory-form">
					<p class="title">
						<img src="@/assets/image/landing/title.png" alt="" />
					</p>
					<div class="content mt-3">
						<div class="label">
							<span>资质类型：</span>
							<!-- <a-input v-model="qualification" placeholder="请输入您的资质类型" /> -->
							<a-select :value="fromData.type" style="width: 120px" @change="typeChange">
								<a-select-option :value="item.id" v-for="(item,index) in passagetype" :key='index'>
									{{item.name}}
								</a-select-option>
							</a-select>
						</div>
						<div class="label">
							<span>所在省份：</span>
							<!-- <a-cascader :options="options" :show-search="{ filter }" placeholder="请选择地区"
								@change="onChange" /> -->
							<a-select :value="fromData.province_name" style="width: 120px" @change="handleChange">
								<a-select-option :value="item.name" v-for="(item,index) in address" :key='index'>
									{{item.name}}
								</a-select-option>
							</a-select>
						</div>
						<div class="label">
							<span>您的姓名：</span>
							<a-input v-model="fromData.username" placeholder="请输入您的姓名" />
						</div>
						<div class="label">
							<span> 联系方式：</span>
							<a-input v-model="fromData.phone" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入您的联系方式" />
						</div>
					</div>
					<div class="btn btn-11" @click="submitInfo">提交</div>
				</div>
			</div>
			<div class="cate pb-3">
				<div class="common-content">
					<div class="common-title">
						<h1 class="name">常见建筑资质类型</h1>
						<h3>COMMON CATEGORY</h3>
					</div>
					<div class="content">

						<div class="home-scenes-main">
							<div class="scenes-menu">
								<div class="flex align-center">
									<h4>业务范围</h4>
									<div class="list">
										<template v-for="(item, index) in categoryList">
											<div class="item" :key="index" @click="setModal">
												{{ item.name }}
											</div>
										</template>
									</div>
								</div>
								<div class="more" @click="setModal">了解更多 >></div>
							</div>
							<div class="scenes-content">
								<div class="list">
									<div class="business flex flex-wrap">
										<div class="business-box flex align-center flex-wrap flex-1">
											<div class="business-box-video bg-cent">
												<video type="video/mp4" autoplay="autoplay" preload="none"
													controls="controls" playsinline="true" webkit-playsinline="true"
													x5-playsinline="true" x5-video-player-type="h5"
													:src="video_url"></video>
											</div>

											<div class="business-box-list" v-for="(item,index) in businessBgList"
												:key="index" @click="setModal">
												<div class="business-box-list-img">
													<div class="bg bg-cent"
														:style="{backgroundImage: 'url(' + item.img + ')'}"> </div>
												</div>
												<div class="business-box-list-b flex align-center justify-between py-2 pl-2 pr-1">
													<div class="test-hide">
														<h4 class="test-hide">{{item.title}}</h4>
														<span class="test-hide">{{item.test}}</span>
													</div>
													<img class="mr-1" src="@/assets/image/home/right.png" />
												</div>
											</div>

										</div>
										<div class="business-right bg-white">
											<div class="business-right-hread flex justify-between align-center">
												<div v-for="(item,index) in tablist" :key="index">
													<div @click="pikerTab(index)" class="tab-list">
														{{item}}
														<span :class="pickrIndex == index ? 'span-status' : '' "></span>
													</div>
												</div>
											</div>
											<div class="business-right-cont mt-4">
												<div class="business-h">
													<div class="business-right-cont-list flex align-center mb-3"
														v-for="(item,index) in  articleData[pickrIndex]" :key="index" @click="setModal">
														<span></span>
														<p class="test-hide w-100 flex-1">{{item}}</p>
													</div>
												</div>
												<div class="business-more flex align-center justify-between">
													<span>了解更多相关信息...</span>
													<img src="@/assets/image/home/right.png" />
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
			<div class="step">
				<div class="common-content">
					<div class="common-title title">
						<h1 class="name">仅需4步 即可取证</h1>
						<h3>FAST PROCESSING</h3>
						<p>标准化处理流程！进行周期比同行替换20％</p>
					</div>
					<div class="content">
						<div class="step-top px-6" @click="setModal">
							<div class="item">
								<div class="img-box">
									<img src="@/assets/image/decoration/071.png" alt="" />
								</div>
								<p class="mt-2">进行预约</p>
								<p class="mt-1">咨询进行所需资料并预约进行</p>
							</div>
							<div class="item">
								<div class="img-box">
									<img src="@/assets/image/decoration/072.png" alt="" />
								</div>
								<p class="mt-2">资料整理</p>
								<p class="mt-1">专家全程协助整理所需资料</p>
							</div>
							<div class="item">
								<div class="img-box">
									<img src="@/assets/image/decoration/073.png" alt="" />
								</div>
								<p class="mt-2">提交审批</p> 
								<p class="mt-1">整理检查无误后，提交至申报系统</p>
							</div>
							<div class="item">
								<div class="img-box">
									<img src="@/assets/image/decoration/074.png" alt="" />
								</div>
								<p class="mt-2">坐等取证</p>
								<p class="mt-1">快速审核途径，公示公告后领取证书</p>
							</div>
						</div>
						<div class="step-form">
							<div class="title">立即预约 了解办理详情</div>  
							<div class="form">
								<div class="label mb-2">
									<span>资质类型：</span>
									<!-- <a-input v-model="qualification" placeholder="请输入资质类型" /> -->
									<a-select :value="fromData.type" style="width: 120px" @change="typeChange">
										<a-select-option :value="item.id" v-for="(item,index) in passagetype" :key='index'>
											{{item.name}}
										</a-select-option>
									</a-select>
								</div>
								<div class="label mb-2">
									<span>所在省份：</span>
									<!-- <a-cascader :options="options" :show-search="{ filter }" placeholder="请选择地区"
										@change="onChange" /> -->
									<a-select :value="fromData.province_name" style="width: 120px" @change="handleChange">
										<a-select-option :value="item.name" v-for="(item,index) in address"
											:key='index'>
											{{item.name}}
										</a-select-option>
									</a-select>
								</div>
								<div class="label">
									<span>您的姓名：</span>
									<a-input v-model="fromData.username" placeholder="请输入您的姓名" />
								</div>
								<div class="label">
									<span> 联系方式：</span>
									<a-input v-model="fromData.phone"  onkeyup="value=value.replace(/[^\d]/g,'')"
										placeholder="请输入您的联系方式" />
								</div>
							</div>
							<div class="btn btn-11" @click="submitInfo">提交</div>
						</div>
					</div>
				</div>
			</div>
			<div class="style">
				<div class="common-content">
					<div class="common-title">
						<h1 class="name">企业风采</h1>
						<h3>CORPORATE STYLE</h3>
						<p>成为专业、诚信、普惠的建筑业咨询公司</p>
					</div>
					<div class="content">
						<img src="@/assets/image/landing/style.png" alt="" />
					</div>
				</div>
			</div>
		<!-- <Footer></Footer> -->
		<div class="footers py-4">
			<div class="footer-info">
			  <div class="phone">
			    <a :href="'tel:4006036669'"><img src="@/assets/image/50.png" alt=""  class="mr-1"/>全国咨询热线:
			      全国咨询热线:400 603 6669</a >
			    <span>( 周一至周日 8:00-22:00 )</span>
			  </div>
			  <p class="nomal copyright">
			    Copyright © 2020 youpudao.com, All rights reserved 版权均归：广东优普道建筑工程咨询服务有限公司 广东省广州市海珠区新港东路1168号101室
			  </p>
			
			  
			  <a class="nomal" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备19100677号</a>
			  
			</div>
		</div>
		</div>
		
	</div>
</template>
<script>
	import landingHeader from "@/components/common/landing-header.vue";
	import Banner from "@/components/common/banner.vue";
	import Footer from "@/components/common/footer.vue";
	import Swiper from "swiper";
	import {
		areaList
	} from "@vant/area-data";

	export default {
		components: {
			landingHeader,
			Banner,
			Footer
		},
		data() {
			return {
				swiperImgs:[
					require('@/assets/image/landing/wswiper1.jpg'),
					require('@/assets/image/landing/wswiper2.jpg'),
					require('@/assets/image/landing/wswiper3.jpg'),
					require('@/assets/image/landing/wswiper4.jpg'),
					require('@/assets/image/landing/wswiper5.jpg')
				],
				modal2Visible:false,
				qualification: "",
				name: "",
				phone: "",
				city_name: "",
				province_name: "",
				banners: {
					list: [{
						img_url_temp: require("@/assets/image/landing/banner.png"),
					}, ],
				},
				options: [],
				areaList,
				address: [],
				addressName: '广东省',
				categoryList: [{
						name: '总承包资质',
						id: 10
					},
					{
						name: '专业承包资质',
						id: 20
					},
					{
						name: '设计类资质',
						id: 30
					},
					{
						name: '其他类资质',
						id: 40
					},
				],
				video_url: 'http://sadmin.youpudao.com/uploads/files/question/20210129/b221c7610476ad43346.mp4',
				businessBgList: [{
						img: require('@/assets/image/home/01037.png'),
						title: '建筑工程总承包',
						test: '效率高，时效快'
					},
					{
						img: require('@/assets/image/home/01038.png'),
						title: '公路工程总承包',
						test: '省心省时省力'
					}, {
						img: require('@/assets/image/home/01039.png'),
						title: '市政工程总承包',
						test: '一站式无忧服务'
					}, {
						img: require('@/assets/image/home/01040.png'),
						title: '机电工程总承包',
						test: '业界口碑信誉好'
					}
				],
				tablist: ['资质标准', '成功案例', '常见问题'],
				articleData: [
					['工程造价咨询企业资质', '安防资质', '承装(修、试)电力设施许可证', '房地产开发企业资质', '安全生产许可证'],
					['助力广州***有限公司办理钢结...',
						'深圳通信工程施工总承包三级新...',
						'成功助力刘先生办理装修装饰工...',
						'助力广东新**建筑工程有限公司...',
						'助力陆先生成功办理水利水电工...'
					],
					['办一个建筑资质多少钱？', '办理一个资质需要多久？', '办理资质我们需要什么条件？', '办资质我能接什么工程？', '资质怎么办理？']
				],
				pickrIndex: 0,
				passagetype:[],
				fromData:{
					  province_name:returnCitySN.cname,
					  type: 10,
					  channel: 40,
					  username: '', 
					  phone: '',
					  requirements: '',
					  source_url: window.location.href,
				}
			};
		},
		created() {
			this.getPassagetype();
			console.log(this.areaList);
			//处理vant拿到的数据
			// 一级
			for (const key in this.areaList.province_list) {
				let data = {
					value: key,
					label: this.areaList.province_list[key],
				};
				this.options.push(data);
			}
			// // 二级
			// for (const key in this.areaList.city_list) {
			//   let data = {
			//     value: key,
			//     label: this.areaList.city_list[key],
			//     children: [],
			//   };
			//   let c = key.substring(0, 2) + "0000";
			//   let index = this.options.findIndex((val) => {
			//     return val.value == c;
			//   });
			//   console.log(data)
			//   this.options[index].children.push(data);
			// }
			// // 三级
			// for (const key in this.areaList.county_list) {
			//   let data = {
			//     value: key,
			//     label: this.areaList.county_list[key],
			//   };
			//   let c = key.substring(0, 2) + "0000";
			//   let b = key.substring(0, 4) + "00";
			//   let index = this.options.findIndex((val) => {
			//     return val.value == c;
			//   });
			//   let idx = this.options[index].children.findIndex((val) => {
			//     return val.value == b;
			//   });
			//   this.options[index].children[idx].children.push(data);
			// }

			// this.getBannerList();
		},
		mounted() {
			setTimeout(()=>{
				this._init_swiper();
			},1000)
			this.$axios.get('http://admin.t.youpudao.cn/api/examarea/areaList').then(res => {
				console.log('res', res.data.data);
				this.address = res.data.data;
			})
		},
		methods: {
			setModal(){
				this.modal2Visible = true ; 
			},
			typeChange(e){
				this.fromData.type = e; 
			},
			getPassagetype() {
			  this.$api.applyCategory().then((res) => {
			    this.passagetype = res.data;
				this.fromData.type = res.data.length != 0 ? res.data[0].id : 10
			  });
			},
			pikerTab(e) {
				this.pickrIndex = e;
			},
			handleChange(e) {
				console.log(e);
				this.fromData.province_name = e;
			},
			submitInfo() {
				// if (this.qualification == "") {
				// 	this.$message.error("请输入资质类型");
				// 	return;
				// }
				if (this.fromData.type == "") {
					this.$message.error("请输入资质类型");
					return;
				}
				if (this.fromData.province_name == "") {
					this.$message.error("请选择所在地区");
					return;
				}
				if (this.fromData.username == "") {
					this.$message.error("请输入你的名字");
					return;
				}
				if (this.fromData.phone == "") {
					this.$message.error("请输入你的电话");
					return;
				}
				if (!/^1[3456789]\d{9}$/.test(this.fromData.phone)) {
					this.$message.error("请输入正确手机号");
					return;
				}
				// let source_url = window.location.href;
				// let data = {
				// 	username: this.name,
				// 	phone: this.phone,
				// 	province_name: this.province_name,
				// 	transaction_aptitude: this.qualification,
				// 	source_url: source_url,
				// };
				// return console.log(this.fromData)
				this.$api.applyOffer(this.fromData).then((res) => {
					this.$message.success("留言提交成功，稍后专业顾问将为你答疑解惑");
					this.fromData.username =  '';
					this.fromData.phone = '';
					this.fromData.province_name = returnCitySN.cname,
					this.modal2Visible = false ;
				});
			},
			onChange(value, selectedOptions) {
				console.log(selectedOptions);
				if (selectedOptions) {
					this.province_name = selectedOptions[0].label;
				} else {
					this.province_nam = "";
				}
			},
			filter(inputValue, path) {
				return path.some(
					(option) =>
					option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
				);
			},
			_init_swiper() {
				var swiper = new Swiper(".advisory-banner .banner-container", {
					autoplay: 2000,
					loop: false,
					pagination: ".advisory-banner .banner-pagination",
				});
			},
			getBannerList() {
				this.$api
					.getBannerList({
						// 10首页  20
						launchPage: 80,
						launchFacility: 10,
					})
					.then((res) => {
						this.banners.list = res.data.list;
					});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.modal-select{
		margin: 15px 0 ;
		/deep/ .ant-select-selection{
			background-color: #f7f7f7;
			border-radius: 8px;
			border: 1px solid #dddddd;
		}
		/deep/ .ant-input{
			background-color: #f7f7f7;
			border-radius: 8px;
			border: 1px solid #dddddd;
		}
	}
	.bg-cent {
		/* background-color: #fff; */
		background-repeat: no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	.flex {
		display: flex;
	}

	.flex-1 {
		flex: 1;
	}

	.align-center {
		align-items: center;
	}

	.justify-between {
		justify-content: space-between;
	}

	.flex-wrap {
		flex-wrap: wrap;
	}

	.test-hide {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.landing-container {
		.main-container {
			.common-content {
				@include container();
				padding-left: 10px;
				padding-right: 10px;
			}

			.common-title {
				position: relative;
				padding-top: 80px;
				padding-bottom: 40px;

				.name {
					font-size: 40px;
					font-weight: bold;
					color: #313131;
					text-align: center;
					position: relative;
					z-index: 2;
				}

				&>h3 {
					width: 100%;
					font-size: 40px;
					font-weight: bold;
					color: rgba(18, 102, 255, 0.24);
					text-align: center;
					position: absolute;
					top: 60px;
					left: 0;
					z-index: 1;
					// transform: translateX(-50%);
				}

				&>p {
					font-size: 24px;
					font-weight: 500;
					color: #313131;
					text-align: center;
				}
			}

			.advisory {
				@include flex-between();

				.advisory-banner {
					width: 60%;
					height: 350px;
					background: #f7f7f7;

					.banner-container {
						height: 100%;

						.banner-img {
							width: 100%;
							height: 100%;
						}

						.banner-pagination {
							height: 38px;
							background: rgba($color: #000000, $alpha: 0.52);
							bottom: 0;
							@include flex-end();
							padding-right: 30px;
							z-index: 9;
						}

						.banner-title {
							height: 38px;
							position: absolute;
							text-align: center;
							transition: 0.3s;
							transform: translate3d(0, 0, 0);
							z-index: 10;
							bottom: 0;
							left: 0;
							font-size: 22px;
							font-weight: bold;
							color: #ffffff;
							z-index: 10;
							line-height: 38px;
							padding-left: 20px;
						}

						/deep/.swiper-pagination-bullet {
							width: 12px;
							height: 12px;
							border: 3px solid #ffffff;
							border-radius: 50%;
							background: transparent;
							opacity: 1;
						}

						/deep/.swiper-pagination-bullet-active {
							background: #ffffff;
						}
					}
				}

				.advisory-form {
					.title {
						width: 100%;
						text-align: center;
						background: #ffffff;
						border-radius: 8px;

						&>span:nth-child(1) {
							font-size: 27px;
							color: #ff5400;
							font-weight: bold;
							font-style: italic;
						}

						&>span:nth-child(2) {
							font-size: 22px;
							font-weight: bold;
							font-style: italic;
							color: #3a6fe5;
						}
					}

					.content {
						.label {
							margin-bottom: 16px;
							@include flex-center();

							&>span:nth-child(1) {
								font-size: 16px;
								font-weight: 400;
								color: #313131;
								margin-right: 10px;
							}

							/deep/.ant-input {
								width: 334px;
								height: 37px;
								background: #f7f7f7;
								border: 1px solid #dddddd;
								border-radius: 8px;
								text-indent: 20px;
								flex: 1;
							}

							/deep/ .ant-select {
								width: 334px !important;
								height: 37px;
								background: #f7f7f7;
								border: 1px solid #dddddd;
								border-radius: 8px;
								text-indent: 10px;
								box-shadow: none !important;
							}

							/deep/.ant-select-selection {
								border: none;
								background-color: transparent;
								height: 37px;
								line-height: 35px !important;
								box-shadow: none !important;
							}

							/deep/.ant-select-selection__rendered {
								line-height: 35px;
							}

							/deep/.ant-input:focus {
								box-shadow: none;
							}

							/deep/.ant-cascader-picker {
								background: #f7f7f7;
							}
						}
					}

					.btn {
						width: 322px;
						height: 40px;
						background: #3a6fe5;
						font-size: 16px;
						color: #ffffff;
						text-align: center;
						line-height: 40px;
						margin: 26px auto 0;
						cursor: pointer;
					}
				}
			}

			.cate {
				background: url("~@/assets/image/landing/cate_bg.png") no-repeat;
				background-size: cover;

				.common-content {
					max-width: 1678px;
				}

				.content {

					max-width: 1200px;
					margin: 0 auto;
					padding: 0 10px;
					// height: 430px;
					// background: #575757; 
				}
			}

			.step {
				background: url("~@/assets/image/landing/step_bg.png") no-repeat;
				background-size: cover;
				padding-bottom: 70px;

				.title {
					&>h3 {
						color: rgba($color: #ffffff, $alpha: 0.12);
					}
				}

				.content {
					.step-top {
						@include flex-between();

						.item {
							@include flex-center(column);

							.img-box {
								width: 88px;
								height: 88px;
								background: #ffffff;
								border-radius: 50%;
								border: 6px solid #4c7be3;
								@include flex-center(column);
							}

							&>p:nth-child(2) {
								font-size: 20px;
								font-weight: bold;
								color: #ffffff;
							}

							&>p:nth-child(3) {
								font-size: 16px;
								color: #ffffff;
								max-width: 160px;
								text-align: center;
							}
						}

						.item:not(:last-child) {
							.img-box {
								position: relative;
								z-index: 2;

								&::after {
									content: "";
									display: block;
									width: 320%;
									height: 4px;
									position: absolute;
									top: 50%;
									left: 70px;
									transform: translateY(-50%);
									background: #ffffff;
									z-index: 1;
								}
							}
						}
					}

					.step-form {
						margin-top: 80px;
						border: 2px solid #6c9bff;
						border-radius: 16px;
						position: relative;
						background: rgba($color: #003dc6, $alpha: 0.5);

						.title {
							position: absolute;
							left: 50%;
							top: -30px;
							transform: translateX(-50%);
							width: 534px;
							height: 60px;
							background: #ff7928;
							border: 2px solid #6c9bff;
							border-radius: 30px;
							font-size: 30px;
							font-family: Source Han Sans CN;
							color: #ffffff;
							text-align: center;
							line-height: 56px;
						}

						.btn {
							width: 365px;
							height: 54px;
							background: #6c9bff;
							position: absolute;
							bottom: -27px;
							left: 50%;
							transform: translateX(-50%);
							font-size: 20px;
							color: #ffffff;
							text-align: center;
							line-height: 54px;
							cursor: pointer;
						}

						.form {
							@include flex-center();
							padding: 60px 80px;
							flex-wrap: wrap;

							.label {
								width: 50%;
								@include flex-center();

								&>span:nth-child(1) {
									font-size: 20px;
									color: #ffffff;
								}

								/deep/.ant-input {
									width: 351px;
									// flex: 1;
									height: 37px;
									background: #f7f7f7;
									border: 1px solid #dddddd;
									padding: 0;
									border-radius: 8px;
									text-indent: 20px;
								}

								/deep/ .ant-select {

									width: 351px !important;

									height: 37px;

									background: #f7f7f7;

									border: 1px solid #dddddd;

									border-radius: 8px;

									text-indent: 10px;

									box-shadow: none !important;

								}

								/deep/.ant-select-selection {

									border: none;

									background-color: transparent;

									height: 37px;

									line-height: 35px !important;

									box-shadow: none !important;

								}

								/deep/.ant-select-selection__rendered {

									line-height: 35px;

								}

								/deep/.ant-cascader-picker {
									border-radius: 8px;
								}
							}
						}
					}
				}
			}

			.style {
				padding-bottom: 90px;

				.content {
					&>img {
						width: 100%;
					}
				}
			}
		
			.footers{
				background: #313131;
				 color: #e5e5e5;
				a{
					 color: #e5e5e5;
				}
				.footer-info{
					max-width: 1200px;
					margin: 0 auto;
					padding: 0 15px;
					.phone{
						    font-size: 22px;
						    font-weight: bold;
						    color: #e5e5e5;
						span{
							font-size: 14px;
						}
					}
					.copyright{
						margin: 10px 0;
					}
				}
			}
		}
	}

	.home-scenes {
		&-main {
			.scenes-menu {
				@include flex-between();

				h4 {
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #383D41;
					margin-right: 25px;
				}

				.list {
					padding: 0 20px;
					@include flex-start();
					border-bottom: 1px solid #383D41;

					.item {
						padding: 0 20px 20px;
						font-size: 16px;
						color: #383D41;
						line-height: 22px;
						cursor: pointer;
					}

					.active {
						color: $primary-color;
						position: relative;

						&::after {
							content: '';
							display: block;
							width: 50px;
							height: 3px;
							background: $primary-color;
							position: absolute;
							bottom: 0;
							left: 50%;
							transform: translateX(-50%);
						}
					}

				}

				.more {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: $descColor;
					line-height: 22px;
					cursor: pointer;
				}
			}

			.scenes-content {
				width: 100%;
				margin-top: 45px;
				@include flex-between();
				align-items: flex-start;

				.scenes-img {
					width: 18%;
					height: 378px;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.list {
					width: 100%;
					// width: 80%;
					@include flex-between();
					// flex-direction:column;
					align-items: flex-start;
					flex-wrap: wrap;
					margin-bottom: 80px;

					.item {
						width: 49%;
						height: 178px;
						padding: 16px 26px;
						border: 1px solid #D9DCE8;
						border-radius: 8px;
						transition: all 0.5s;

						&:nth-child(3) {
							margin-top: 20px;
						}

						&:nth-child(4) {
							margin-top: 20px;
						}

						&:hover {
							transform: scale(1.02);
							transition: all 0.5s;
						}

						.top {
							@include flex-between();

							.title {
								width: 70%;
								@include ellipsis();
								font-size: 20px;
								color: $text-color;
							}

							.more {
								width: 103px;
								height: 30px;
								background: #FFFFFF;
								border: 1px solid $primary-color;
								border-radius: 8px;
								color: $primary-color;
							}
						}

						.content {

							@include flex-between();
							flex-wrap: wrap;

							li {
								width: 30%;
								padding: 10px 0;
								@include ellipsis();

								span {
									color: #FF3B0E;
								}

								&:nth-child(2n+1) {
									width: 70%;
								}
							}
						}
					}

					// 首页 建筑企业股权转让
					.list-cont {
						width: 24.5%;
						height: 200px;
						padding: 18px 12px;
						border: 1px solid #D9DCE8;

						// margin-left: 7px;
						.list-cont-img {
							width: 114px;
							height: 167px;
							background: #9BA7BB;
							margin-right: 12px;
						}

						.list-cont-box {
							flex: 1;

							h5 {

								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #383D41;
							}

							p {

								font-size: 12px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #7C7E86;
							}

							p:nth-child(1) {
								margin-bottom: 15px;
							}

							p:nth-child(2) {
								margin-bottom: 7px;
							}

							.list-cont-box-btn {
								margin-top: 27px;

								span {

									font-size: 13px;
									font-family: Source Han Sans CN;
									font-weight: 400;
									color: #E03838;
								}

								button {
									width: 74px;
									height: 28px;
									background: #335ED9;
									font-size: 13px;
									font-family: Source Han Sans CN;
									font-weight: 400;
									color: #FFFFFF;
									line-height: 28px;
									text-align: center;
								}
							}
						}
					}

					// 首页 建筑资质服务全场景覆盖
					.business {
						.business-box {
							.business-box-video {
								width: 532px;
								height: 220px;
								background: #100F10;
								border: 1px solid #D9DCE8;
								margin-right: 9px;
								// background: #000088;
								margin-bottom: 13px;

								video {
									width: 100%;
									height: 100%;
								}
							}

							.business-box-list {
								cursor: pointer;
								transition: all 0.6s;

								&:hover {
									box-shadow: 0 2px 4px rgba(0, 0, 0, .12);

									.bg {
										transform: scale(1.1, 1.1);
									}

									.business-box-list-b img {
										margin-right: 0;
									}
								}

								width: 260px;
								height: 220px;
								background: #ffffff;
								margin-right: 10px;
								margin-bottom: 13px;

								.business-box-list-img {
									width: 260px;
									height: 146px;
									overflow: hidden;

									.bg {
										width: 100%;
										height: 100%;
										transition: all 0.6s;
									}
								}

								.business-box-list-b {
									h4 {
										font-size: 16px;
										font-family: Source Han Sans CN;
										font-weight: 400;
										color: #383D41;
										line-height: 22px;
									}

									span {

										font-size: 12px;
										font-family: Source Han Sans CN;
										font-weight: 400;
										color: #7C7E86;
										line-height: 22px;
									}

									img {
										transition: all 0.6s;
									}
								}

							}

						}

						.business-right {
							padding: 24px;
							width: 345px;
							height: 452px;
							// margin-left: 15px;
							background: #FFFFFF;

							.business-right-hread {
								// padding: 24px;
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #383D41;
								line-height: 22px;
								cursor: pointer;

								.tab-list {
									position: relative;
									height: 30px;

									span {
										position: absolute;
										bottom: 0;
										left: 50%;
										margin-left: -19px;
										width: 38px;
										height: 2px;
									}

									.span-status {
										background: #335ED9;
									}
								}
							}

							.business-right-cont {
								.business-right-cont-list {
									cursor: pointer;
									align-items: center;

									&:hover {
										p {
											color: #335ED9;
										}
									}

									span {
										width: 6px;
										height: 6px;
										background: #335ED9;
										border-radius: 50%;
										margin-right: 10px;
									}

									p {
										font-size: 16px;
										font-family: Source Han Sans CN;
										font-weight: 400;
										color: #7C7E86;
										line-height: 22px;
										transition: all 0.2s;
									}
								}
							}

							.business-h {
								height: 285px;
							}

							.business-more {
								cursor: pointer;
								border-top: 1px solid #DBDBDB;
								padding: 25px 0 0 0;
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #A3A6A9;

								&:hover img {
									margin-right: -10px;
								}

								img {
									width: 28px;
									height: 28px;
									transition: all 0.6s;
								}
							}
						}
					}

					.noDate {
						width: 100%;
						height: 100%;
						@include flex-center(column);
						color: #E5E5E5;

						img {
							width: 100px;

						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: 1170px) {

		.landing-container .main-container {
			.advisory {
				flex-wrap: wrap;

				.advisory-banner {
					margin: 0 auto;
					max-width: 100%;
				}

				.advisory-form {
					margin: 20px auto;
				}
			}

			.step .content {
				.step-top {
					flex-wrap: wrap;
					padding: 0;

					.item {
						width: 50%;
						margin-bottom: 20px;
					}

					.item:not(:last-child) .img-box::after {
						width: 0;
					}
				}

				.step-form {
					.form{
					    padding: 70px 30px;
						.label {
							margin-bottom: 20px;
							width: 100%;
							.ant-input {
								flex: 1;
							}
							.ant-select{
								flex: 1;
							}
						}
				} 
					.btn{
						width: 40%;
						font-size: 16px;
					}
				}
			}

		}

		.home-scenes-main .scenes-content .list .business .business-box {
			.business-box-video {
				width: 65%;
			}

			.business-box-list {
				width: 30%;

				.business-box-list-img {
					width: 100%;
				}
			}
		}

	}

	@media only screen and (max-width: 1024px) {
		.home-scenes-main .scenes-content .list .business .business-box {
			display: flex;
			justify-content: space-between;

			.business-box-video {
				width: 100%;
			}

			.business-box-list {
				width: 23%;
				margin-right: 0;
				.business-box-list-img {
					width: 100%;
				}
			}
		}
	}

	@media only screen and (max-width: 750px) {
		.landing-container .main-container {
			.common-title .name{
				font-size: 30px;
			}
			.common-title > h3{
				font-size: 30px;
			}
			.common-title > p{
				font-size: 18px;
			}
			.advisory .advisory-form {
				width: 100%;
				padding:0 15px;
				.content .label .ant-select {
					// width: 100% !important;
					flex: 1;
				}
			}

			.step .content .step-form .title {
				width: 80%;
				font-size: 18px;
			}
			
		}

		.home-scenes-main .scenes-content .list{
			margin-bottom: 30px;
		.business {
			.business-box {
				display: flex;
				justify-content: space-between;
				flex: auto;
				width: 100%;

				.business-box-video {
					width: 100%;
					margin-right: 0;
				}

				.business-box-list {
					width: 48%;
					margin-right: 0;

					.business-box-list-img {
						width: 100%;
					}
				}

				.business-right {
					width: 100%;
				}
			}

			.business-right {
				width: 100%;
				height: auto;
				.business-right-cont .business-right-cont-list{
					margin-bottom: 15px;
				}
			}
			.business-right-cont{
				margin-top: 20px;
				.business-h{
					height: auto;
					margin-bottom: 20px;
				}
			}
		}
	
		} 
		.landing-container .main-container .advisory .advisory-form .content .label > span:nth-child(1){
			font-size: 14px;
		}
		.landing-container .main-container .step .content{
			.step-top .item > p:nth-child(2){
				font-size: 16px;
			}
			.step-top .item > p:nth-child(3){
				font-size: 12px;
			}
			.step-form .form .label > span:nth-child(1){
				font-size: 14px;
			}
		} 
		.business-box-list-b{
			padding: 10px;
		}
		.home-scenes-main .scenes-menu {
			h4{
				display: none;
			}
			.list{
				text-align: center;
			}
		} 
		
		.landing-container .main-container .advisory .advisory-banner{
			height: 210px;
			width: 100%;
			.banner-container .banner-title{
				font-size: 16px;
			}
		}
		// .landing-container .main-container .advisory .advisory-banner .banner-container .banner-title[data-v-c3c408c2]
	}

	@media only screen and (max-width: 481px) {

		.landing-container .main-container .advisory .advisory-form {
			.btn {
				width: 60%;
			}

			.title {
				img {
					width: 100%;
				}
			}
		}

		.home-scenes {
			&-main {
				.scenes-menu {
					@include flex-between();

					.list {


						.item {
							padding: 0 10px 10px;
							font-size: 14px;
						}

					}

					.more {
						display: none;
					}
				}

				.scenes-content {
					margin-top: 30px;

					.scenes-img {
						height: 86px;
					}

					.list {

						.item {
							margin-top: 20px;
							width: 100%;
							height: auto;

							&:hover {
								transform: scale(1);
							}

							.top {
								.title {
									font-size: 16px;
								}

								.more {

									font-size: 16px;
									width: 94px;
									height: 26px;

								}
							}

							.content {
								li {
									font-size: 14px;
								}
							}
						}

						.noDate {
							margin-top: 40px;
						}
					}
				}
			}
		}

	}
	
	
	
	.btn-11 {
	    border: none;
	    background: rgb(251, 33, 117);
	    /* background: linear-gradient(0deg, rgba(251, 33, 117, 1) 0%, rgba(234, 76, 137, 1) 100%); */
	    color: #fff;
	    overflow: hidden;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		display: block;
		box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
		7px 7px 20px 0px rgba(0, 0, 0, .1),
		4px 4px 5px 0px rgba(0, 0, 0, .1);
		outline: none;
	  }
	
	  .btn-11:hover {
	    text-decoration: none;
	    color: #fff;
	  }
	
	  .btn-11:before {
	    position: absolute;
	    content: '';
	    display: inline-block;
	    top: -180px;
	    left: 0;
	    width: 30px;
	    height: 100%;
	    background-color: #fff;
	    animation: shiny-btn1 2s ease-in-out infinite;
	  }
	
	  .btn-11:hover {
	    opacity: .7;
	  }
	
	 .btn-11:active {
	    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .3),
	    -4px -4px 6px 0 rgba(116, 125, 136, .2),
	    inset -4px -4px 6px 0 rgba(255, 255, 255, .2),
	    inset 4px 4px 6px 0 rgba(0, 0, 0, .2);
	  }
	
	
	  @-webkit-keyframes shiny-btn1 {
	    0% {
	      -webkit-transform: scale(0) rotate(45deg);
	      opacity: 0;
	    }
	    80% {
	      -webkit-transform: scale(0) rotate(45deg);
	      opacity: 0.5;
	    }
	    81% {
	      -webkit-transform: scale(4) rotate(45deg);
	      opacity: 1;
	    }
	    100% {
	      -webkit-transform: scale(50) rotate(45deg);
	      opacity: 0;
	    }
	  }
</style>
